"use client"
import React, {FC} from 'react';
import VisibilityIcon from '@mui/icons-material/Visibility';
// import {useRouter} from 'next/router';
import {Row} from "@/core/general/row.component";
import {Column} from "@/core/general/column.component";
import {VideoListModel} from "@/core/model/video.model";
import {toPersianNumber} from "@/core/utils/number.utils";
import { useRouter } from 'next/navigation'
import {VideoGardiLngModel, VideoGardiModel} from "@/core/model/tmk.model";

interface ShortcutProps {
  video: VideoGardiModel;
  sourceUrl: string | null;
}

const VideoSwiperShortcutComponent: FC<ShortcutProps> = (props) => {
  const router = useRouter();

  function videoClick(id: string,title:string) {
    router.push(`media/${id}?shTitle=${title}`);
  }

  return (
    <div className="w-full">
      {props.video ? (
        <Column className="p-1 cursor-pointer" onClick={() => videoClick(String(props.video.id),(props.video.title as VideoGardiLngModel).fa)}>
          <div className="aspect-[16/9] overflow-hidden relative rounded card card-box videoBannerIconImage">
            <img alt="" src={props.video.gallery?.thumbnail??""} className="videoImageBlur" />
            <img alt="" src={props.video.gallery?.thumbnail??""} className="videoImage" />
          </div>
          <Row className="text-wrap p-1 mText">
            <div className="fs-7 p-1 grow text-start text-wrap overflow-hidden h-10" style={{ maxWidth: '10rem' }}>
              {(props.video.title as VideoGardiLngModel).fa??""}
            </div>
            <div className="flex flex-row w-auto justify-end">
              <div className="fs-7 text-end p-1">{toPersianNumber(props.video.views.toString())}</div>
              <VisibilityIcon className={'mt-1'} fontSize={'small'} />
            </div>
          </Row>
        </Column>
      ) : null}
    </div>
  );
};

export default React.memo(VideoSwiperShortcutComponent)
